<template>
  <b-container class="mt-3 mt-md-5">
    <b-row>
      <b-col sm="12" class="p-0">
        <b-card no-body class="p-0">
          <div class="card shadow">
            <div class="card-header bg-transparent p-0">
              <h3 class="float-left mb-0 ml-3">
                {{ $tc("message.medicalAdvice") }}
              </h3>
              <div class="card-body">
                <!--  <div class="card-title ml-3">
                                </div> -->
                <b-container fluid class="p-0 m-0">
                  <section class="container" id="appointment-table">
                    <div class="appointment-table-header my-2 mb-4">
                      <b-button @click="onAddClick" v-if="can || userIsMed">
                        <i class="fa fa-plus edit-icon"></i>
                        {{ $t("message.add") }}
                      </b-button>

                      <div
                        v-if="paginationObject.numOfPages > 1"
                        class="pagination-wrapper d-inline-block"
                      >
                        <div class="pagination">
                          <a
                            href="#"
                            :class="
                              'prev page-numbers ' +
                              (paginationObject.currentPageNumber === 1
                                ? 'pagination-disabled'
                                : '')
                            "
                            @click="handlePaginationClick('prev')"
                          >
                            <i
                              aria-hidden="true"
                              class="v-icon fas fa-chevron-left"
                            ></i>
                          </a>
                          <template
                            v-for="(
                              pageNumber, key
                            ) in paginationObject.listOfPageNumber()"
                          >
                            <template
                              v-if="
                                pageNumber ===
                                paginationObject.currentPageNumber
                              "
                            >
                              <span
                                :key="key"
                                aria-current="page"
                                class="page-numbers current"
                              >
                                {{ pageNumber }}
                              </span>
                            </template>
                            <template v-else>
                              <a
                                href="#"
                                :key="key"
                                class="page-numbers"
                                @click="handlePaginationClick(pageNumber)"
                              >
                                {{ pageNumber }}
                              </a>
                            </template>
                          </template>
                          <a
                            href="#"
                            class="next page-numbers"
                            :class="
                              'next page-numbers ' +
                              (paginationObject.currentPageNumber ===
                              paginationObject.numOfPages
                                ? 'pagination-disabled'
                                : '')
                            "
                            @click="handlePaginationClick('next')"
                          >
                            <i
                              aria-hidden="true"
                              class="v-icon fas fa-chevron-right"
                            ></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="row appointment-table-content p-0 m-0">
                      <div class="container-fluid p-0 m-0">
                        <template
                          v-if="
                            paginationObject.display(
                              paginationObject.currentPageNumber
                            ).length > 0
                          "
                        >
                          <div
                            v-for="(
                              medicalAdvice, key
                            ) in paginationObject.display(
                              paginationObject.currentPageNumber
                            )"
                            class="row appointment-item"
                            :key="key"
                          >
                            <div class="col-lg-3">
                              <span class="appointment-label">
                                {{ $t("message.date") }}
                              </span>
                              <!-- {{ medicalAdvice }} -->
                              <h4 class="appointment-date">
                                {{
                                  dateMedicalAdvice(
                                    medicalAdvice.created_at,
                                    "date"
                                  )
                                }}
                              </h4>
                              <span class="appointment-label">
                                {{ $t("message.time") }}
                              </span>
                              <h4 class="appointment-hour">
                                {{
                                  dateMedicalAdvice(
                                    medicalAdvice.created_at,
                                    "hour"
                                  )
                                }}
                              </h4>
                            </div>
                            <div class="col-lg-3">
                              <span class="appointment-label">
                                {{ $t("message.nomPatient") }}
                              </span>
                              <h4
                                class="patient-name"
                                @click="
                                  onGoToMedicalFileClick(
                                    medicalAdvice.dossier.slug
                                  )
                                "
                                v-if="
                                  medicalAdvice.dossier !== null &&
                                  medicalAdvice.dossier.patient.user !== null
                                "
                              >
                                {{
                                  medicalAdvice.dossier.patient.user.nom +
                                  " " +
                                  medicalAdvice.dossier.patient.user.prenom
                                }}

                                <!-- {{medicalAdvice.dossier.patient ? medicalAdvice.dossier.patient.user.nom : '' + ' ' + medicalAdvice.dossier.patient ? medicalAdvice.dossier.patient.user.prenom : ''}} -->
                              </h4>
                              <!--<b-link :to="{name: 'medical-file', params: {file: medicalAdvice.dossier.patient.dossier_medical.slug}}">
                                                                {{appointment.patient.nom + ' ' + appointment.patient.prenom}}
                                                            </b-link>-->
                              <span class="appointment-label">
                                {{ $t("message.doctorName") }}
                              </span>
                              <h4>
                                {{ displayDoctor(medicalAdvice.medecin_avis) }}
                              </h4>
                              <br />
                              <div class="medical-advice-badges">
                                <template v-if="isReceiver(medicalAdvice)">
                                  <b-badge
                                    v-if="!hasReceiverViewed(medicalAdvice)"
                                    variant="danger"
                                    class="mr-2"
                                  >
                                    {{ $t("message.notViewed") }}
                                  </b-badge>

                                  <b-badge
                                    v-else
                                    variant="success"
                                    class="mr-2"
                                  >
                                    {{ $t("message.viewed") }}
                                  </b-badge>

                                  <b-badge
                                    v-if="!hasReceiverResponded(medicalAdvice)"
                                    variant="danger"
                                    class="mr-2"
                                  >
                                    {{ $t("message.notResponded") }}
                                  </b-badge>
                                  <b-badge
                                    v-else
                                    variant="success"
                                    class="mr-2"
                                  >
                                    {{ $t("message.responded") }}
                                  </b-badge>
                                </template>

                                <template v-else>
                                  <b-badge
                                    v-if="!contentAnyResponse(medicalAdvice)"
                                    variant="danger"
                                    class="mr-2"
                                  >
                                    {{ $t("message.notResponded") }}
                                  </b-badge>
                                  <b-badge
                                    v-else
                                    variant="success"
                                    class="mr-2"
                                  >
                                    {{ $t("message.responded") }}
                                  </b-badge>
                                </template>
                              </div>
                            </div>
                            <div class="col-lg-3">
                              <span class="appointment-label">
                                {{ $t("message.objectAdvice") }}
                              </span>
                              <h4 class="appointment-date">
                                {{ medicalAdvice.objet }}
                              </h4>

                              <span class="appointment-label">
                                {{ $t("message.description") }}
                              </span>
                              <p
                                class="appointment-motif mb-0"
                                v-html="medicalAdvice.description"
                              ></p>
                            </div>
                            <div class="col-lg-3">
                              <b-button
                                variant="primary"
                                size="sm"
                                class="mb-2"
                                v-if="
                                  isReceiver(medicalAdvice) &&
                                  !hasCurrentUserResponded(medicalAdvice)
                                "
                                @click="
                                  onResponseToMedicalAdvice(medicalAdvice.slug)
                                "
                              >
                                <i class="fa fa-reply"></i>
                                {{ $t("message.response") }}
                              </b-button>
                              <b-badge
                                :variant="
                                  getVariantCodeEmergency(
                                    medicalAdvice.code_urgence
                                  )
                                "
                                class="mr-2"
                              >
                                {{
                                  $t(getCodeName(medicalAdvice.code_urgence))
                                }}
                              </b-badge>
                              <br />
                              <b-dropdown
                                dropdown
                                text="action"
                                variant="primary"
                                class="mt-2"
                                size="sm"
                              >
                                <b-dropdown-item
                                  href="#"
                                  @click="onShowClick(medicalAdvice.slug)"
                                >
                                  {{ $t("message.show") }}
                                </b-dropdown-item>

                                <b-dropdown-item
                                  href="#"
                                  v-if="!!medicalAdvice.creer_lien"
                                  @click="
                                    onGoToMedicalFileClick(
                                      medicalAdvice.dossier.slug
                                    )
                                  "
                                >
                                  {{ $t("message.medicaleFolder") }}
                                </b-dropdown-item>

                                <b-dropdown-item
                                  href="#"
                                  v-if="isEmitter(medicalAdvice)"
                                  @click="onEditClick(medicalAdvice.slug)"
                                >
                                  {{ $t("message.edit") }}
                                </b-dropdown-item>

                                <b-dropdown-item
                                  href="#"
                                  v-if="isEmitter(medicalAdvice)"
                                  @click="showDeleteModal(medicalAdvice)"
                                >
                                  {{ $t("message.delete") }}
                                </b-dropdown-item>
                              </b-dropdown>
                            </div>
                            <!--<span
                                                                class="appointment-item-status-mobile &#45;&#45;danger"
                                                                :class="'appointment-item-status-mobile ' + getStatusClass(appointment.statut)"
                                                        >
                                                            <span class="badge badge-success">
                                                                {{appointment.statut}}
                                                            </span>
                                                        </span>-->
                          </div>
                        </template>

                        <template v-else>
                          <h4>{{ $t("message.noItemToDisplay") }}</h4>
                        </template>
                      </div>
                    </div>
                    <div class="row appointment-table-footer"></div>
                  </section>
                </b-container>
              </div>
            </div>
            <section>
              <b-modal
                size="sm"
                id="delete-medicalAdvice"
                header-bg-variant="danger"
                header-text-variant="light"
                :title="
                  $t('message.delete') + ' ' + $t('message.medicalAdvice')
                "
                hide-footer
              >
                <div class="d-block text-center">
                  <h3>{{ $t("message.deleteConfirmation") }}</h3>
                </div>

                <div class="d-block float-right">
                  <b-button
                    variant="danger"
                    @click="$bvModal.hide('delete-medicalAdvice')"
                  >
                    {{ $t("message.cancel") }}
                  </b-button>

                  <b-button
                    variant="secondary"
                    @click="handleDeleteMedicalAdvice"
                  >
                    {{ $t("message.delete") }}
                  </b-button>
                </div>
              </b-modal>
            </section>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
import * as _ from "lodash";
import router from "../../router/router";
import moment from "moment";

export default {
  name: "MedicalAdvice",
  computed: {
    ...mapGetters([
      "medicalAdvices",
      "hasAssistante",
      "hasPraticienRole",
      "hasMedecinControleRole",
    ]),
    can: function () {
      return (
        this.hasAdminRole ||
        this.hasGestionnaireRole ||
        this.hasPraticienRole ||
        this.hasAssistante ||
        this.hasMedecinControleRole
      );
    },
  },
  userIsMed: function () {
    return JSON.parse(localStorage.getItem("user"))["isMedicasure"];
  },

  data() {
    return {
      showTable: false,
      paginationObject: {},
      medicalAdviceToDelete: {},
      user: JSON.parse(localStorage.getItem("user")),
    };
  },
  watch: {
    medicalAdvices: function (newMedicalAdvices, oldMedicalAdvices) {
      // console.log('newMedicalAdvices => ', newMedicalAdvices);

      const filteredMedicalAdvices = newMedicalAdvices.filter(
        (advice) =>
          this.isEmitter(advice) ||
          this.isReceiver(advice) ||
          this.hasAssistante
      );

      this.paginationObject = this.Pagination(filteredMedicalAdvices, 10);
    },
    filterCriteria: function (newValue, oldValue) {
      this.handleFilter(newValue);
    },
  },
  methods: {
    dateMedicalAdvice(created_at, type) {
      switch (type) {
        case "date":
          return moment(created_at).format("ddd, Do MMM YYYY");
        case "hour":
          return moment(created_at).format("HH:mm");
      }
    },
    isEmitter(avis) {
      return avis.creator === this.user.id;
    },

    isReceiver(avis) {
      return (
        avis.medecin_avis.filter((m) => m.medecin_id === this.user.id).length >
        0
      );
    },

    hasCurrentUserResponded(avis) {
      return (
        this.isReceiver(avis) &&
        !!avis.medecin_avis.find((m) => m.medecin_id === this.user.id).avis
      );
    },

    onResponseToMedicalAdvice(slug) {
      router.push({
        name: "response-medical-advice",
        params: {
          medicalAdviceSlug: slug,
        },
      });
    },

    contentAnyResponse(avis) {
      return avis.medecin_avis.filter((m) => m.avis).length > 0;
    },

    hasReceiverResponded(avis) {
      return avis.medecin_avis.find((m) => m.medecin_id).avis;
    },

    hasReceiverViewed(avis) {
      return Boolean(Number(avis.medecin_avis.find((m) => m.medecin_id).view));
    },

    displayDoctor(doctors) {
      let distinctDoctors = _.map(
        _.uniqBy(doctors, "medecin_id"),
        function (item) {
          return item;
        }
      );

      return distinctDoctors
        .map((doctor) => {
          if (typeof doctor.medecin == "object" && doctor.medecin != null) {
            return doctor.medecin.nom + " " + doctor.medecin.prenom;
          }
        })
        .join(", ");
    },

    getCreateLinkStatus(shouldCreateLink, isClass = false) {
      return !!shouldCreateLink
        ? !isClass
          ? "message.boundToPatientMedicalFolder"
          : "--success"
        : !isClass
        ? "message.notBoundToPatientMedicalFolder"
        : "--warning";
    },

    getClass(text) {
      if (/[a-g]/.test(text[0].toLowerCase())) {
        return "bg-green";
      } else if (/[h-k]/.test(text[0].toLowerCase())) {
        return "bg-red";
      } else if (/[l-r]/.test(text[0].toLowerCase())) {
        return "bg-blue";
      } else {
        return "bg-dark";
      }
      // return text;
      // switch (text) {
      //     case 'Dentiste': return 'bg-green';
      //     case 'Orthopédie': return 'bg-red';
      //     case 'Génerale': return 'bg-blue';
      //     default: return '';
      // }
    },

    showDeleteModal(medicalAdvice) {
      event.preventDefault();
      this.medicalAdviceToDelete = medicalAdvice;
      this.$bvModal.show("delete-medicalAdvice");
    },

    getListOfMedicalAdvices() {
      this.$store.dispatch("getMedicalAdvices", { args: {} });
    },

    handleDeleteMedicalAdvice() {
      event.preventDefault();

      const successMessage = this.$i18n.t("message.medicalAdviceDeleted");
      const errorMessages = {
        generic: this.$i18n.t("message.genericError"),
        error: this.$i18n.t("message.genericError"), // TODO: Prendre message approprié
      };

      const payload = {
        args: {},
        slug: this.medicalAdviceToDelete.slug,
        errorMessages,
        successMessage,
      };

      this.$store.dispatch("deleteMedicalAdvice", payload).then(() => {
        this.getListOfMedicalAdvices();
        this.$bvModal.hide("delete-medicalAdvice");
        this.medicalAdviceToDelete = null;
      });
    },

    errorshasField(field) {
      return this.errors ? this.errors.hasOwnProperty(field) : false;
    },

    clearErrorField(field) {
      this.$store.dispatch("clearErrorField", { field });

      this.errorshasField(field);
    },

    onGoToMedicalFileClick(slug) {
      // router.push({ name: 'medical-file', params: {file: slug} });
      router.push(
        router.resolve({ name: "medical-file", params: { file: slug } }).href +
          "#generale"
      );
    },

    onAddClick() {
      event.preventDefault();
      router.push({ name: "add-medical-advice" });
    },

    onEditClick(slug) {
      event.preventDefault();
      router.push({
        name: "edit-medical-advice",
        params: { medicalAdviceSlug: slug },
      });
    },

    onShowClick(slug) {
      event.preventDefault();
      router.push({
        name: "show-medical-advice",
        params: { medicalAdviceSlug: slug },
      });
    },

    handlerOnFilterButton() {
      event.preventDefault();
      // this.handleFilter(this.filterCriteria);
    },

    handlePaginationClick(action) {
      event.preventDefault();

      // If we want to go to the previous page
      if (action === "prev") {
        if (this.paginationObject.currentPageNumber - 1 >= 1)
          this.paginationObject.currentPageNumber =
            this.paginationObject.currentPageNumber - 1;
      }

      // If we want to go to the next page
      else if (action === "next") {
        if (
          this.paginationObject.currentPageNumber + 1 <=
          this.paginationObject.numOfPages
        )
          this.paginationObject.currentPageNumber =
            this.paginationObject.currentPageNumber + 1;
      }

      // If we want to go to a particular page
      else {
        const numberOfPageToGoTo = Number(action);
        if (
          numberOfPageToGoTo <= this.paginationObject.numOfPages &&
          numberOfPageToGoTo >= 1
        )
          this.paginationObject.currentPageNumber = numberOfPageToGoTo;
      }
    },

    Pagination(pageEleArr, numOfEleToDisplayPerPage) {
      // Create an object to easily manipulate property linked
      const result = {};
      // Added a new property to hold the list of elements
      result.pageEleArr = pageEleArr;

      // Added a new property to hold the number of item to display per page
      result.numOfEleToDisplayPerPage = numOfEleToDisplayPerPage;

      // Added a new property to hold the total number of items
      result.elementCount = result.pageEleArr.length;

      // Added a new property to hold the number of items to display per page
      result.numOfPages = Math.ceil(
        result.elementCount / result.numOfEleToDisplayPerPage
      );

      // Set the current page number to 1
      result.currentPageNumber = 1;

      result.listOfPageNumber = function () {
        const listOfPageNumber = [];
        for (let i = 1; i < result.numOfPages + 1; i++) {
          listOfPageNumber.push(i);
        }
        return listOfPageNumber;
      };

      // Function to get the various list item per page
      // Return Array[Array]
      const pageElementsArr = function (arr, eleDispCount) {
        const arrLen = arr.length;
        const noOfPages = Math.ceil(arrLen / eleDispCount);
        const pageArr = [];

        let perPageArr = [],
          index = 0,
          condition = 0,
          remainingEleInArr = 0;

        for (let i = 0; i < noOfPages; i++) {
          if (i === 0) {
            index = 0;
            condition = eleDispCount;
          }
          // Create an list of items of a page
          for (let j = index; j < condition && j < arrLen; j++) {
            perPageArr.push(arr[j]);
          }

          // insert that list into then global list
          pageArr.push(perPageArr);

          if (i === 0) {
            remainingEleInArr = arrLen - perPageArr.length;
          } else {
            remainingEleInArr = remainingEleInArr - perPageArr.length;
          }

          if (remainingEleInArr > 0) {
            if (remainingEleInArr > eleDispCount) {
              index = index + eleDispCount;
              condition = condition + eleDispCount;
            } else {
              index = index + perPageArr.length;
              condition = condition + remainingEleInArr;
            }
          }
          perPageArr = [];
        }
        return pageArr;
      };

      // Main method to get a list of a particular page
      result.display = function (pageNo) {
        // If the asked page is not in the range of available pages
        if (pageNo > result.numOfPages || pageNo <= 0) {
          return [];
        } else {
          // Get the total list
          const totalList = pageElementsArr(
            result.pageEleArr,
            result.numOfEleToDisplayPerPage
          );

          // Return the list of the pageNo
          return totalList[[pageNo - 1]];
        }
      };

      // Return the pagination object
      return result;
    },

    getVariantCodeEmergency(emergencyCode) {
      if (emergencyCode.toLowerCase() === "normal") {
        return "primary";
      } else if (emergencyCode.toLowerCase() === "urgent") {
        return "warning";
      } else return "danger";
    },

    getCodeName(emergencyCode) {
      if (emergencyCode.toLowerCase() === "normal") {
        return "message.normal";
      } else if (emergencyCode.toLowerCase() === "urgent") {
        return "message.urgent";
      } else return "message.ultraUrgent";
    },
  },
  mounted() {
    this.getListOfMedicalAdvices();
  },
};
</script>

<style scoped lang="scss">
@import url("~slim-select/dist/slimselect.min.css");
#appointment-table {
  $black: #121212;
  $primary-color: #2dcecc;

  .appointment-table-header {
    @mixin breakpoint($value) {
      @if $value == "phone" {
        @media only screen and (min-width: 120px) and (max-width: 767px) {
          @content;
        }
      } @else if $value == "tablet" {
        @media only screen and (min-width: 768px) and (max-width: 1024px) {
          @content;
        }
      } @else if $value == "touch" {
        @media only screen and (min-width: 120px) and (max-width: 1024px) {
          @content;
        }
      } @else if $value == "desktop" {
        @media only screen and (min-width: 1025px) {
          @content;
        }
      } @else {
        @media only screen and (max-width: $value) {
          @content;
        }
      }
    }

    & + button {
      height: 30px !important;
    }

    .pagination-wrapper {
      text-align: center;
      /*margin: 40px 0;*/
    }

    .pagination {
      /*display: inline-block;*/
      height: 30px;
      /*margin-top: 70px;*/
      /*padding: 0 15px;*/
      border-radius: 35px;
      /*background-color: $primary-color;*/

      @include breakpoint(1199px) {
        height: 20px;
        /*margin-top: 50px;*/
        padding: 0 10px;
        border-radius: 25px;
      }
    }

    .page-numbers {
      display: block;
      padding: 0 15px;
      float: left;
      transition: all 0.3s;
      color: gray;
      font-size: 20px;
      letter-spacing: 0.1em;
      line-height: 30px;
      border-radius: 7px;

      &:hover,
      &.current {
        background-color: $primary-color;
        color: #fff;
      }

      &.prev:hover,
      &.next:hover {
        background-color: transparent;
        color: $primary-color;
      }

      @include breakpoint(1199px) {
        padding: 0 15px;
        font-size: 16px;
        line-height: 20px;
      }

      @include breakpoint(touch) {
        padding: 0 14px;
        display: none;

        &:nth-of-type(2) {
          position: relative;
          padding-right: 50px;

          &::after {
            content: "...";
            position: absolute;
            font-size: 25px;
            top: 0;
            left: 45px;
          }
        }

        &:nth-child(-n + 3),
        &:nth-last-child(-n + 3) {
          display: block;
        }

        &:nth-last-child(-n + 4) {
          padding-right: 14px;

          &::after {
            content: none;
          }
        }
      }

      &.pagination-disabled {
        opacity: 0.3;
      }
    }

    button {
      padding: 5px 10px;
      box-shadow: 0 3px 3px rgba(50, 50, 93, 0.1), 0 2px 4px rgba(0, 0, 0, 0.08);
    }

    .appointment-pagination-btn {
      font-weight: 600;
      font-size: 13px;
      padding: 8px 10px;
      margin-left: 4px;
      cursor: pointer;
      box-shadow: 0 3px 3px rgba(50, 50, 93, 0.1), 0 2px 4px rgba(0, 0, 0, 0.08);

      &:last-child {
        margin-right: 5px;
      }

      &:hover {
        color: #000;
      }
    }
  }

  .appointment-item {
    position: relative;
    padding-top: 15px;
    padding-bottom: 24px;
    border-top: 0.5px solid rgba(0, 0, 0, 0.3);
    /*cursor: pointer;*/

    /*@media only screen and (max-width: 576px) {*/
    /*    margin-top: 40px;*/
    /*    margin-bottom: 40px;*/
    /*}*/

    .patient-name:hover {
      cursor: pointer;
      opacity: 0.6;
    }

    .color-success {
      color: $primary-color !important;
    }

    .color-danger {
      color: red !important;
    }

    /*&:hover {*/
    /*    opacity: 0.8;*/
    /*}*/

    &:after {
      content: unset;
      height: 1px;
      width: 86%;
      background: rgba(0, 0, 0, 0.5);
      opacity: 0.3;
      position: absolute;
      top: 0;
      left: 14px;

      @media only screen and (max-width: 576px) {
        bottom: -20px;
      }
    }

    &:last-child {
      &:after {
        content: unset;
      }
    }

    /*& > div {
                position: relative;
                &:before {
                    content: ' ';
                    width: 1px;
                    height: 50%;
                    background: rgba(0, 0, 0, 0.5);
                    opacity: 0.3;
                    position: absolute;
                    left: -15px;
                    top: 20%;
                }
            }

            & > div:first-child {
                &:before {
                    content: unset;
                }
            }*/

    .appointment-hour {
      opacity: 0.9;
    }

    .appointment-label {
      opacity: 0.9;
      color: $black;
      font-size: 10px;
      font-weight: 500;
      letter-spacing: 0.4px;
      text-transform: uppercase;
    }

    .appointment-item-status {
      color: $black;
      position: relative;
      margin-left: 15px;

      @media only screen and (max-width: 996px) {
        display: none;
      }

      span {
        font-weight: 600;
      }

      &:before {
        content: " ";
        width: 5px;
        height: 5px;
        background: black;
        position: absolute;
        left: -15px;
        top: 6px;
        border-radius: 50%;
      }

      &.--success {
        color: $primary-color !important;
        &:before {
          background: $primary-color !important;
        }
      }

      &.--warning {
        color: #968b2a !important;
        &:before {
          background: #968b2a !important;
        }
      }

      &.--danger {
        color: #fa3a0e !important;
        &:before {
          background: #fa3a0e !important;
        }
      }
    }

    .appointment-item-status-mobile {
      display: none;
      position: absolute;
      right: 25%;

      span {
        font-weight: 600;
      }

      @media only screen and (max-width: 576px) {
        right: 5px;
      }

      @media only screen and (max-width: 996px) {
        display: block;
      }
    }
  }
}
</style>
